import React, { useRef } from "react";
import { StyledAutocomplete, StyledTextField, StyledDiv, StyledIconContainer } from "./custom-dropdown.styled";

import PropTypes from "prop-types";
import VirtualizedListbox from "../virtualized-listbox/virtualized-listbox";

const CustomDropdown = ({
    options,
    color,
    label,
    noOptionsText,
    labelPropName,
    renderOption,
    disabled,
    Icon,
    onChange,
    value,
    virtualScroll = false,
}) => {
    const divRef = useRef(null);
    const getOptionLabel = (option) => {
        if (!option[labelPropName]) return "";
        const hasEmployeeCode = option["employeeCode"];
        return hasEmployeeCode ? option[labelPropName] + " (" + option["employeeCode"] + ")" : option[labelPropName];
    };

    const renderPopupIcon = () =>{
        return (
               <StyledIconContainer
                        style={{
                            pointerEvents: disabled ? "none" : "initial",
                        }}
                        color={color}
                    >
                        <Icon style={{ width: "32px", height: "32px" }} />
                    </StyledIconContainer>
        )
    }
    return (
        <StyledDiv ref={divRef}>
            <StyledAutocomplete
                sx={{
                    "& .MuiAutocomplete-popupIndicator": { transform: "none" },
                }}
                disableListWrap
                disableClearable
                noOptionsText={noOptionsText}
                options={options}
                onChange={onChange}
                disabled={disabled}
                value={value}
                autoHighlight
                renderOption={renderOption}
                getOptionLabel={getOptionLabel}
                ListboxComponent={virtualScroll ? VirtualizedListbox : undefined}
                popupIcon={renderPopupIcon()}
                renderInput={(params) => (
                    <StyledTextField
                        {...params}
                        sx={{
                            "& .MuiOutlinedInput-root.Mui-focused": {
                                "& > fieldset": {
                                    borderColor: color,
                                },
                            },
                        }}
                        label={label}
                        InputLabelProps={{
                            style: { color: color },
                        }}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: "off", // disable autocomplete and autofill
                        }}
                    />
                )}
            />
        </StyledDiv>
    );
};

CustomDropdown.propTypes = {
    options: PropTypes.array,
    label: PropTypes.string,
    color: PropTypes.string,
    noOptionsText: PropTypes.string,
    labelPropName: PropTypes.string,
    renderOption: PropTypes.any,
    Icon: PropTypes.any,
    onChange: PropTypes.func,
    value: PropTypes.object,
};

export default CustomDropdown;
